import { render, staticRenderFns } from "./Newslist.vue?vue&type=template&id=891a317e&"
import script from "./Newslist.vue?vue&type=script&lang=js&"
export * from "./Newslist.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports